'use client';

import { usePathname } from "next/navigation";
import HTTPErrorPage from "./HTTPErrorPage";
import { Link } from "../components/Link";

export default function HTTP404NotFoundPage() {
	const pathname = usePathname();
	return <HTTPErrorPage
		httpStatus={404}
		statusCatAltText="404 - Not Found. Funny picture of a cat buried underneath various documents on the floor. The cat appears to be searching these documents."
		cheekyText={<>
			<p>
				We searched high and low, but the page <code>{pathname}</code> doesn&rsquo;t seem to exist this side of Narnia.
			</p>
			<p>
				If you&rsquo;ve followed a link from somewhere, it might be out of date.
				If you typed the address in manually, make sure the White Witch&rsquo;s spies didn&rsquo;t sneak any typos in.
			</p>
			<p>
				If nothing else, you could always try finding the nearest wardrobe and see where it
				takes you&mdash;or head back to the <Link href="/">home page</Link>. You could also use the
				nifty button below to go back to where you came from.
			</p>
		</>}
	/>;
}
